export const OPERATING_FLUID_URL_ADDRESS = 'operatingfluids.mercedes-benz.com';
export enum UrlsCollection {
    PRIVACY_POLICY_LINK = 'https://group.mercedes-benz.com/datenschutzrichtlinie',
    ONLINE_DISPUTE_LINK = 'https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage',
    Provider_MAIL_ADDRESS = 'dialog@mercedes-benz.com',
    OPERATING_FLUID_MAIL_ADDRESS = 'operatingfluids@mercedes-benz.com',
    MBOX_DATENSCHUTZ_ADRESS = 'mbox_datenschutz@mercedes-benz.com',
    DIGITAL_VEHICLE_MANUAL_LINK_DE = 'https://www.mercedes-benz.de/passengercars/services/manuals.html',
    DIGITAL_VEHICLE_MANUAL_LINK_EN = 'https://www.mercedes-benz.co.uk/passengercars/services/manuals.html',
}
